import { render, staticRenderFns } from "./SearchPanoramaSubjects.vue?vue&type=template&id=4a8d1dc2&scoped=true"
import script from "./SearchPanoramaSubjects.vue?vue&type=script&lang=js"
export * from "./SearchPanoramaSubjects.vue?vue&type=script&lang=js"
import style0 from "./SearchPanoramaSubjects.vue?vue&type=style&index=0&id=4a8d1dc2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8d1dc2",
  null
  
)

export default component.exports